import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import FullscreenDialog from '@components/Modals/components/FullscreenDialog';
import { imageFullWidthSmAndUp } from '@style/variables';
import { classNames } from '@repo/ui/src/utils/classNames';

const GalleryDialog = ({ open, onClose, images, useImagePadding }) => {
  return (
    <FullscreenDialog open={open} onClose={onClose} dark>
      <div className="tw-px-6 sm:tw-px-15" data-testID="dialog-content">
        {images.map(
          (image, i) =>
            image && (
              <div
                className={classNames(
                  'tw-w-full tw-mb-6 tw-text-center md:tw-h-[70vh] tw-flex tw-justify-center',
                  useImagePadding && 'tw-p-6 tw-bg-neutral-500',
                )}
                key={i}
                data-testID="image-container"
              >
                <img
                  src={buildImageSrc(image, imageFullWidthSmAndUp, 0, 0)}
                  alt={image.name}
                  data-testId="carousel-image"
                  className="tw-object-cover"
                />
              </div>
            ),
        )}
      </div>
    </FullscreenDialog>
  );
};

export default GalleryDialog;
